import { render } from "./NzebView.vue?vue&type=template&id=ef407648"
const script = {}

import "./NzebView.vue?vue&type=style&index=0&id=ef407648&lang=css"

import exportComponent from "D:\\Backup\\Sunville\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__